import React from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'default' | 'lg';
}
export function Button({
  className,
  variant = 'primary',
  size = 'default',
  children,
  ...props
}: ButtonProps) {
  return <button className={cn(
  // Base styles
  'inline-flex items-center justify-center uppercase tracking-expanded font-semibold transition-all duration-500 ease-out focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-charcoal disabled:opacity-50 disabled:pointer-events-none',
  // Sharp corners
  'rounded-none',
  // Variants
  variant === 'primary' && 'border border-gold text-gold bg-transparent hover:bg-gold hover:text-charcoal', variant === 'secondary' && 'bg-charcoal border border-gold text-white hover:scale-105 hover:bg-deepCharcoal', variant === 'outline' && 'border border-white text-white hover:bg-white hover:text-charcoal',
  // Sizes
  size === 'default' && 'text-lg px-10 py-4',
  // 20px 60px padding requested, adjusted for scale
  size === 'lg' && 'text-xl px-14 py-6', className)} {...props} data-id="element-188">
      {children}
    </button>;
}